// CustomIcons.js

import markerBusBlue from "@/assets/icons/markerBusBlue.svg";
import markerBusGreen from "@/assets/icons/markerBusGreen.svg";
import markerBusOrange from "@/assets/icons/markerBusOrange.svg";
import markerBusRed from "@/assets/icons/markerBusRed.svg";
import markerFerryBlue from "@/assets/icons/markerFerryBlue.svg";
import markerFerryGreen from "@/assets/icons/markerFerryGreen.svg";
import markerFerryOrange from "@/assets/icons/markerFerryOrange.svg";
import markerFerryRed from "@/assets/icons/markerFerryRed.svg";
import markerMetroBlue from "@/assets/icons/markerMetroBlue.svg";
import markerMetroGreen from "@/assets/icons/markerMetroGreen.svg";
import markerMetroOrange from "@/assets/icons/markerMetroOrange.svg";
import markerMetroRed from "@/assets/icons/markerMetroRed.svg";
import markerTramBlue from "@/assets/icons/markerTramBlue.svg";
import markerTramGreen from "@/assets/icons/markerTramGreen.svg";
import markerTramOrange from "@/assets/icons/markerTramOrange.svg";
import markerTramRed from "@/assets/icons/markerTramRed.svg";
import marker from "@/assets/icons/marker.svg";

const CustomIcons = [
  { src: markerBusBlue, name: "markerBusBlue-svg" },
  { src: markerBusGreen, name: "markerBusGreen-svg" },
  { src: markerBusOrange, name: "markerBusOrange-svg" },
  { src: markerBusRed, name: "markerBusRed-svg" },
  { src: markerFerryBlue, name: "markerFerryBlue-svg" },
  { src: markerFerryGreen, name: "markerFerryGreen-svg" },
  { src: markerFerryOrange, name: "markerFerryOrange-svg" },
  { src: markerFerryRed, name: "markerFerryRed-svg" },
  { src: markerMetroBlue, name: "markerMetroBlue-svg" },
  { src: markerMetroGreen, name: "markerMetroGreen-svg" },
  { src: markerMetroOrange, name: "markerMetroOrange-svg" },
  { src: markerMetroRed, name: "markerMetroRed-svg" },
  { src: markerTramBlue, name: "markerTramBlue-svg" },
  { src: markerTramGreen, name: "markerTramGreen-svg" },
  { src: markerTramOrange, name: "markerTramOrange-svg" },
  { src: markerTramRed, name: "markerTramRed-svg" },
  { src: marker, name: "marker-svg" },
];

export default CustomIcons;
